import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faCheck, faEdit, faTractor, faTruck } from '@fortawesome/free-solid-svg-icons';
import { withToastManager } from 'react-toast-notifications';
import { DataTable, Loading } from '../../components';
import APIClient from '../../services/APIClient';
import { connect } from 'react-redux';


class AutoModeloList extends React.Component {
  static propTypes = {
    toastManager: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      autoModelos: [],
      isDataLoading: true,
    };

    this.loadAutoModelos = this.loadAutoModelos.bind(this);
  }


  getPermissions(){
    const {isSuperAdmin, editPermission,deletePermission,isPermissionsLoading} = this.props.permissionsUser;
    this.setState({
      isSuperAdmin,
      editPermission,
      deletePermission,
      isPermissionsLoading,
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.permissionsUser !== this.props.permissionsUser) {
      this.getPermissions();
    }
  }
  

  componentDidMount() {
    this.loadAutoModelos();
  }

  loadAutoModelos() {
    const { toastManager } = this.props;

    APIClient.get('/auto-modelos')
      .then((res) => {
        this.setState({
          autoModelos: res.data.data,
          isDataLoading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        toastManager.add(`Ocurrió un error: "${err.message}"`, {
          appearance: 'error',
        });
        this.setState({
          isDataLoading: false,
        });
      });
  }

  getVehiculoTipoIcon = (cell, row, rowIndex, formatExtraData) => <FontAwesomeIcon icon={formatExtraData[cell]} />;

  render() {
    const { autoModelos, isDataLoading, isSuperAdmin, editPermission, isPermissionsLoading } = this.state;

    const columns = [
      {
        dataField: 'autoMarca.descripcion',
        text: 'Marca',
        sort: true,
      },
      {
        dataField: 'descripcion',
        text: 'Descripción',
        sort: true,
      },
      {
        dataField: 'motor',
        text: 'Motor',
        sort: true,
      },
      {
        dataField: 'version',
        text: 'Versión',
        sort: true,
      },
      {
        dataField: 'año',
        text: 'Año',
        sort: true,
      },
      {
        dataField: 'vehiculoTipo',
        text: 'Vehículo Tipo',
        sort: true,
        formatter: this.getVehiculoTipoIcon,
        formatExtraData: {
          1: faCar,
          3: faTruck,
          4: faTractor,
        },
      },
      {
        dataField: 'activo',
        text: 'Activo',
        sort: true,
        formatter: (cellContent) => {
          if (cellContent > 0) {
            return <FontAwesomeIcon icon={faCheck} fixedWidth size="xs" />;
          }
        },
      },
      {
        dataField: 'actions',
        isDummyField: true,
        text: '',
        formatter: (cellContent, row) => (
          <ButtonToolbar>
            <ButtonGroup>
              {isSuperAdmin || editPermission ? (
                <>
                  <LinkContainer to={`/auto-modelos/${row.id}`}>
                    <Button size="sm" variant="outline-primary" title="Editar">
                      <FontAwesomeIcon icon={faEdit} fixedWidth size="xs" />
                    </Button>
                  </LinkContainer>
                </>
              ) : (
                <></>
              )}
            </ButtonGroup>
          </ButtonToolbar>
        ),
      },
    ];

    return (
      <div>
        <h1 className="page-title">Modelos de Auto</h1>
        {isPermissionsLoading === false ? (
          <DataTable
            columns={columns}
            data={autoModelos}
            isDataLoading={isDataLoading}
            keyField="id"
            addButton={isSuperAdmin || editPermission ? '/auto-modelos/nuevo' : null}
          />
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

const mapStateToProps = (permissionsUser) => (permissionsUser);

export default connect(mapStateToProps)(withToastManager(AutoModeloList));

